import styled from 'styled-components';

export const StyledNameOfCompetitionWrapper = styled.div`
    border: 3px solid #f1e977;
    padding: 12px 22px;
    max-width: 240px;
    margin: 16px 0;
`;
